import { useEffect, useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtDay, useMe } from "@/lib/api";
import { useCheckout } from "@/lib/useCheckout";

const seenKey = (u) => `dz_upgrade_prompt_${u.period_start}`;

export default function UpgradeDialog() {
  const { data: me } = useMe();
  const { checkout, busy } = useCheckout();
  const [open, setOpen] = useState(false);
  const u = me?.usage;

  useEffect(() => {
    if (u && u.plan === "free" && u.remaining === 0 && !localStorage.getItem(seenKey(u))) setOpen(true);
  }, [u]);

  const close = (v) => {
    if (!v && u) localStorage.setItem(seenKey(u), "1");
    setOpen(v);
  };

  if (!u) return null;
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="sm:max-w-md" data-testid="upgrade-dialog">
        <DialogHeader>
          <div className="w-11 h-11 rounded-md bg-amber-100 text-amber-600 grid place-items-center mb-2"><Sparkles size={20} /></div>
          <DialogTitle className="font-heading text-2xl">Nice work - that case is zipped!</DialogTitle>
          <DialogDescription className="text-slate-600">
            You've used your free export for this cycle. The next one unlocks on {fmtDay(u.period_end)}. Go Pro to export as many cases as you need, starting now.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 mt-2">
          <button data-testid="upgrade-dialog-yearly-btn" disabled={!!busy} onClick={() => checkout("yearly")} className="h-12 rounded-md bg-[#1E293B] text-white font-semibold hover:bg-blue-600 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {busy === "yearly" && <Loader2 size={16} className="animate-spin" />} Pro Yearly - $99.99/yr <span className="text-xs font-normal text-amber-300">save 17%</span>
          </button>
          <button data-testid="upgrade-dialog-monthly-btn" disabled={!!busy} onClick={() => checkout("monthly")} className="h-12 rounded-md border border-slate-300 font-semibold hover:bg-slate-50 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {busy === "monthly" && <Loader2 size={16} className="animate-spin" />} Pro Monthly - $9.99/mo
          </button>
          <button data-testid="upgrade-dialog-dismiss-btn" onClick={() => close(false)} className="h-9 text-sm text-slate-500 hover:text-slate-800">Maybe later</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
